import {
  PersonAddAlt1,
  GroupAdd,
  Build,
  ReceiptLong,
  Paid,
  Description,
  CalendarMonth
} from "@mui/icons-material";
import { Grid } from "@mui/material";
import WSKpiCard from "../../Components/CardGrid/WSKpi";

const KPIDash = ({
  totalLeads,
  activeCustomers,
  installedProjects,
  pendingInvoices,
  paidRevenue,
  quotesSent,
  siteVisits,
  isLoading
}: {
  totalLeads: number;
  activeCustomers: number;
  installedProjects: number;
  pendingInvoices: number;
  paidRevenue: number;
  quotesSent: number;
  siteVisits: number;
  isLoading:boolean;
}) => {
  return (
    <Grid container spacing={3} mb={4} mt={3}>
      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Total Leads"
          value={totalLeads}
          icon={<PersonAddAlt1 sx={{ color: "#0D47A1" }} />}
          iconBgColor="#90CAF9"
          cardBgColor="#E3F2FD"
          valueColor="#0D47A1"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Active Customers"
          value={activeCustomers}
          icon={<GroupAdd sx={{ color: "#6A1B9A" }} />}
          iconBgColor="#E1BEE7"
          cardBgColor="#F3E5F5"
          valueColor="#6A1B9A"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Projects Installed"
          value={installedProjects}
          icon={<Build sx={{ color: "#2E7D32" }} />}
          iconBgColor="#C8E6C9"
          cardBgColor="#E8F5E9"
          valueColor="#2E7D32"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Pending Invoices"
          value={pendingInvoices}
          icon={<ReceiptLong sx={{ color: "#AD1457" }} />}
          iconBgColor="#F8BBD0"
          cardBgColor="#FCE4EC"
          valueColor="#AD1457"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Revenue This Month"
          value={paidRevenue}
          icon={<Paid sx={{ color: "#1B5E20" }} />}
          iconBgColor="#A5D6A7"
          cardBgColor="#E8F5E9"
          valueColor="#1B5E20"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Quotes Sent"
          value={quotesSent}
          icon={<Description sx={{ color: "#4E342E" }} />}
          iconBgColor="#D7CCC8"
          cardBgColor="#EFEBE9"
          valueColor="#4E342E"
          isLoading={isLoading}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <WSKpiCard
          title="Upcoming Site Visits"
          value={siteVisits}
          icon={<CalendarMonth sx={{ color: "#01579B" }} />}
          iconBgColor="#81D4FA"
          cardBgColor="#E1F5FE"
          valueColor="#01579B"
          isLoading={isLoading}
        />
      </Grid>
    </Grid>
  );
};


export default KPIDash;
